{
  "slug": "what-is-iq",
  "title": "IQとは？意味と測定できること",
  "description": "IQの意味、知能検査が測る能力、標準得点の考え方、そして一つの数字では測れないことを解説します。",
  "summary": "IQは、特定の認知課題の成績を同年齢の基準集団と比較して表す標準得点です。知性のすべてや人の価値を示すものではありません。",
  "category": "IQの基礎",
  "sections": [
    {
      "heading": "IQ得点が表すもの",
      "paragraphs": [
        "現代の検査は複数の課題を組み合わせ、代表的な基準集団と比較します。多くの尺度は平均を100に設定しているため、得点は絶対量ではなく相対的な位置を表します。",
        "得点は推定値です。健康、言語、動機、検査環境、形式への慣れ、測定誤差などが影響します。"
      ]
    },
    {
      "heading": "一般的に評価される能力",
      "paragraphs": [
        "専門的な検査は一種類のパズルだけでなく、言語理解、視覚・流動性推理、ワーキングメモリ、注意、処理速度などを標本化します。",
        "同じ総合得点でも、領域ごとの強みと弱みは人によって異なります。"
      ]
    },
    {
      "heading": "IQが測らないもの",
      "paragraphs": [
        "創造性、実践的判断、好奇心、感情面の技能、動機、知恵、専門知識を完全には表しません。将来や人の価値を決定する数字でもありません。",
        "臨床、教育、法的な判断には、資格を持つ専門家による適切な評価が必要です。"
      ]
    }
  ],
  "faqs": [
    {
      "question": "IQは何の略ですか？",
      "answer": "Intelligence Quotient（知能指数）の略で、選ばれた認知課題の成績を年齢基準と比較した標準得点です。"
    },
    {
      "question": "オンラインIQテストは診断ですか？",
      "answer": "いいえ。オンライン結果は参考用の推定であり、専門家による診断の代わりにはなりません。"
    }
  ],
  "related": ["how-is-iq-measured", "what-is-the-average-iq", "free-online-iq-test-guide"],
  "sources": [
    {
      "label": "APA Dictionary of Psychology — IQ",
      "url": "https://dictionary.apa.org/iq"
    }
  ]
}
